import React from 'react';
import PropTypes from 'prop-types';
import { TopActions, ButtonGroup, ActionButton } from './styles';

const ActionBar = ({ onMoveToRental, onMoveToBridge, onMoveToPrimary, group, onNotMine, disabled }) => {
  const buttonConfigs = {
    bridge: [
      { label: 'Move to Rental', onClick: onMoveToRental },
      { label: 'Move to Primary', onClick: onMoveToPrimary },
      { label: 'Not Mine', onClick: onNotMine },
    ],
    rental: [
      { label: 'Move to Bridge', onClick: onMoveToBridge },
      { label: 'Move to Primary', onClick: onMoveToPrimary },
      { label: 'Not Mine', onClick: onNotMine },
    ],
    primary: [
      { label: 'Move to Bridge', onClick: onMoveToBridge },
      { label: 'Move to Rental', onClick: onMoveToRental },
      { label: 'Not Mine', onClick: onNotMine },
    ],
  };

  const currentButtons = buttonConfigs[group] || [];

  return (
    <TopActions>
      <ButtonGroup>
        {currentButtons.map((button, index) => (
          <ActionButton
            key={index}
            type="button"
            onClick={button.onClick}
            disabled={disabled}
          >
            {button.label}
          </ActionButton>
        ))}
      </ButtonGroup>
    </TopActions>
  );
};

ActionBar.propTypes = {
  onMoveToRental: PropTypes.func.isRequired,
  onMoveToBridge: PropTypes.func.isRequired,
  onMoveToPrimary: PropTypes.func.isRequired,
  onNotMine: PropTypes.func.isRequired,
  group: PropTypes.oneOf(['fix_and_flips', 'investment_properties_owned', 'primary_residence']).isRequired,
  disabled: PropTypes.bool,
};

ActionBar.defaultProps = {
  disabled: false,
};

export default ActionBar;
